/* eslint-disable */
($ => {
  $(function onReady() {
    setTimeout(() => {
      const $menus = $(".top-bar, .menu-bar, .submenu-bar");
      $menus.each(function(i, elem) {
        initMenu($(elem));
      });

      initMenuMode();
      initMobileMenus();
      langHover();

      if ($(".blog.post-full").length) {
        initProgressBar();
      }

      else if ($(".document.post-full").length) {
        initProgressBar();
      }

      initFooter();
      $(window).on("resize", initFooter);
    }, 200);
  });

  const langHover = Drupal.debounce(() => {
    $(".links div.dropdown-toggle").bootstrapDropdownHover();
  }, 100);

  $(document).on(
    "click",
    "#block-mainnavigationredesign .dropdown-menu",
    function(e) {
      e.stopPropagation();
    }
  );

  function initMenu($menu) {
    $menu.bootstrapDropdownHover();

    // The main navigation redesign has a mega menu that requires more spaces.
    // Since Bootstrap aligns dropdowns to its parent, we need to override the left property.
    $menu.find(".mbr-desktop-main-nav .dropdown-menu").each(function() {
      const $dropdown = $(this).parents(".dropdown");
      const $dropdownMenu = $(this);

      $dropdownMenu.addClass("mega-menu");

      $dropdown.on("shown.bs.dropdown", () => {
        const { left } = $dropdownMenu[0].getBoundingClientRect();
        $dropdownMenu.css({ left: -left });
      });

      $dropdown.on("hidden.bs.dropdown", () => {
        $dropdownMenu.css({ left: "" });
      });
    });

    if (!$menu.hasClass("top-bar")) {
      addMenuOverlays($menu);
    }

    document.addEventListener(
      "scroll",
      Drupal.debounce(function(e) {
        const $openedMenu = $(".menu .dropdown.open");
        if ($openedMenu.length) {
          $openedMenu
            .removeClass("open")
            .trigger("hide.bs.dropdown")
            .trigger("hidden.bs.dropdown");
        }
      }),
      true
    );
  }

  function addMenuOverlays($menu) {
    const $dropdown = $menu.find(".dropdown");

    $dropdown
      .append('<div class="menu-overlay-shadow">')
      .find(".dropdown-menu")
      .append('<li class="menu-overlay dropdown-toggle">');

    $dropdown.on("shown.bs.dropdown", function() {
      const $dropdownMenu = $(this).find(".dropdown-menu");
      const $menuOverlay = $dropdownMenu.find(".menu-overlay");
      const $menuShadowOverlay = $(this).find(".menu-overlay-shadow");

      $menuOverlay.css({ height: $dropdownMenu.outerHeight() });

      if (!$dropdownMenu.hasClass("mega-menu")) {
        $menuOverlay.css({ left: -$(this).offset().left });
      }

      let top =
        $(".menu-bar").height() +
        $(".top-bar").height() +
        $dropdownMenu.position().top;

      const $siteAlert = $(".site-alert");
      if ($siteAlert.length) top += $siteAlert.height();

      const $localization = $(".localization-block");
      if ($localization.length) top += $localization.outerHeight(true);

      const $adminToolbar = $("#toolbar-bar");
      if ($adminToolbar.length) top += $adminToolbar.height();

      const $adminToolbarTray = $("#toolbar-item-administration-tray");
      if ($adminToolbarTray.length) top += $adminToolbarTray.height();

      $menuShadowOverlay.css({ top });
    });
  }

  function initProgressBar() {
    const $target = $(".submenu-bar").length
      ? $(".submenu-bar")
      : $(".menu-bar");

    $target
      .addClass("with-progress")
      .append(
        '<div class="progress"><div class="progress-bar" role="progressbar"></div></div>'
      );

    $(window).scroll(() => {
      //get total page height
      let docHeight = $(document).height();
      //get total window height
      let winHeight = $(window).height();
      //calculate viewport height
      let viewport = docHeight - winHeight;
      //get current scroll position
      let scrollPos = $(window).scrollTop();
      //get current scroll percentage
      let scrollPercent = (scrollPos / viewport) * 100;

      $(".progress-bar").css({
        width: scrollPercent + "%",
        transition: "width 0.1s"
      });
    });
  }

  function initMenuMode() {
    const $menuWrapper = $(".sticky-header");
    const $topMenu = $(".top-bar");
    const $stickyHeaderSubMenu = $(".sticky-header .submenu-bar");
    const $mainMenu = $(".menu-bar");
    const $secondaryMenu = $(".submenu-bar");
    const $alertBlock = $(".site-alert > div");
    const $header = $("header");
    var contentPlacement =
      $(".sticky-header").position().top + $(".sticky-header").height();

    let menuClass;
    let $menuTarget;
    let menuWrapperClass;
    let $menuWrapperTarget;

    // If submenu exists in sticky header and there is no site alert
    // if ($stickyHeaderSubMenu.length && !$alertBlock.length) {
    //   $menuTarget = $menuWrapper;
    //   menuClass = $(".page-fixed-bar").length ? "fixed-bar" : "sticky-bar";
    // }
    // If submenu exists in sticky header and site alert exists
    if ($stickyHeaderSubMenu.length && $alertBlock.length) {
      $menuTarget = $menuWrapper;
      menuClass = "sticky-bar submenu-alert";
    }
    // If submenu does not exist in sticky header but still exists below header
    else if ($secondaryMenu.length && !$stickyHeaderSubMenu.length) {
      menuWrapperClass = "not-fixed";
      $menuTarget = $secondaryMenu;
      menuClass = "sticky-bar submenu-below-header";
      $menuWrapperTarget = $menuWrapper;
      $menuWrapperTarget.addClass(menuWrapperClass);
    }
    // Every other instance, fire this
    else {
      $menuTarget = $menuWrapper;
      menuClass = "sticky-bar no-submenu";
    }

    $menuTarget.addClass(menuClass);

    // Margin logic for Desktop
    if (window.matchMedia("(min-width: 768px)").matches) {
      // If sticky header has not-fixed class, do not set margin top on header
      if (
        $menuWrapper.hasClass("not-fixed") &&
        !$menuWrapper.hasClass("no-submenu") &&
        !$("body").hasClass("user-logged-in")
      ) {
        $("#page .main-container > header > section:first-child").css(
          "margin-top",
          0
        );
      }
      // If user is logged in and on a page with no submenu
      else if (
        $("body").hasClass("user-logged-in") &&
        $menuWrapper.hasClass("not-fixed") &&
        $menuWrapper.hasClass("no-submenu") &&
        $(".menu-bar .container").children().length > 1
      ) {
        var contentPlacement =
          $(".sticky-header").position().top +
          $(".sticky-header").height() -
          $("#toolbar-administration .toolbar-bar").height() -
          $("#toolbar-item-administration-tray").height();
        $("#page .main-container > header > section:first-child").css(
          "margin-top",
          contentPlacement
        );
      }
      // If user is logged in and is on blog nodes
      else if (
        $("body").hasClass("user-logged-in") &&
        !$menuWrapper.hasClass("not-fixed") &&
        $menuWrapper.hasClass("submenu-alert")
      ) {
        var contentPlacement =
          $(".sticky-header").position().top +
          $(".sticky-header").height() -
          $(".submenu-bar").height();
        $("#page .main-container > header > section:first-child").css(
          "margin-top",
          contentPlacement
        );
      }
      // If user is logged in and on resource nodes
      else if (
        ($("body").hasClass("user-logged-in") &&
          $menuWrapper.hasClass("not-fixed") &&
          $secondaryMenu.hasClass("submenu-below-header")) ||
        ($("body").hasClass("user-logged-in") &&
          !$menuWrapper.hasClass("not-fixed") &&
          $secondaryMenu.hasClass("resource-submenu") &&
          !$secondaryMenu.hasClass("top-subnav"))
      ) {
        $(".user-logged-in #page .main-container").css("margin-top", 0);
      }
      // If user is logged in and has a submenu below header
      else if (
        $("body").hasClass("user-logged-in") &&
        !$menuWrapper.hasClass("not-fixed") &&
        !$secondaryMenu.hasClass("submenu-below-header") &&
        !$menuWrapper.hasClass("no-submenu") &&
        $menuWrapper.hasClass("sticky-bar")
      ) {
        $(".user-logged-in #page .main-container").css("margin-top", 79);
      }
      // If menu is hidden and logged-in
      else if (
        $("body").hasClass("user-logged-in") &&
        $menuWrapper.hasClass("not-fixed") &&
        $menuWrapper.hasClass("no-submenu") &&
        $(".menu-bar .container").children().length < 2
      ) {
        $(".menu-bar .menu-bar-brand").css("margin-top", 0);
        $("body.user-logged-in #page .main-container .page-content").css(
          "margin-top",
          32
        );
        $("body.user-logged-in .main-container").css("margin-top", 59);
        $("body.user-logged-in .sticky-header.no-submenu").addClass("no-menu");
      }
      // If logged-in and resource type with no submenu
      else if (
        $("body").hasClass("user-logged-in") &&
        $("body").hasClass("page-node-type-resource") &&
        $menuWrapper.hasClass("no-submenu")
      ) {
        $(
          "body.user-logged-in #page .main-container > header > section:first-child"
        ).css("margin-top", 0);
      }
      // If logged-in and document type with no submenu
      else if (
        $("body").hasClass("user-logged-in") &&
        $("body").hasClass("page-node-type-document") &&
        $menuWrapper.hasClass("no-submenu")
      ) {
        $("body.user-logged-in.page-node-type-document #page .main-container .sticky-bar").css("top", 80);
        $(
          "body.user-logged-in #page .main-container > header > section:first-child"
        ).css("margin-top", 0);

        $("body.user-logged-in.page-node-type-document #page .main-container").css(
          "margin-top",
          158
        );
      }

      // If menu is hidden and not-logged-in
      else if (
        !$("body").hasClass("user-logged-in") &&
        $menuWrapper.hasClass("not-fixed") &&
        $menuWrapper.hasClass("no-submenu") &&
        $(".menu-bar .container").children().length < 2
      ) {
        var val = 0;
        $(".menu-bar .menu-bar-brand").css("margin-top", 0);
        $("#page .main-container .page-content").css("margin-top", 32);
        $(".main-container").css("margin-top", 59);
        $(".sticky-header.no-submenu").addClass("no-menu");
      }
      // If user is logged in and on the front page
      else if (
        $("body").hasClass("user-logged-in") &&
        $("body").hasClass("path-frontpage")
      ) {
        $(".user-logged-in #page .main-container").css("margin-top", 79);
      }
      // If user is not logged in and header section has resource landing class, apply specific margin
      else if (
        $("#page .main-container > header > section:first-child").hasClass(
          "block-views-blockresource-hero-landing-page-hero-block"
        ) &&
        !$("body").hasClass("user-logged-in")
      ) {
        $("#page .main-container > header > section:first-child").css(
          "margin-top",
          79
        );
      }
      // If user is not logged in and you are on a job post node, apply specific margin
      else if (
        $("body").hasClass("page-node-type-jobpost") &&
        !$("body").hasClass("user-logged-in")
      ) {
        $(".page-node-type-jobpost #page .main-container header .hero").css(
          "margin-top",
          79
        );
      }

      // If user is not logged in and on a page with no submenu
      else if (
        !$("body").hasClass("user-logged-in") &&
        $menuWrapper.hasClass("not-fixed") &&
        $menuWrapper.hasClass("no-submenu") &&
        !$("#page .main-container .components > div").hasClass(
          "contact-hero-bg"
        ) &&
        !$("#page .main-container .components > div").hasClass(
          "onespan-switch-hero-bg"
        )
      ) {
        var contentPlacement =
          $(".sticky-header").position().top + $(".sticky-header").height();
        $("#page .main-container > header").css("margin-top", contentPlacement);
      }
      // If user is not logged in and on a page with no submenu
      else if (
        !$("body").hasClass("user-logged-in") &&
        $menuWrapper.hasClass("not-fixed") &&
        $menuWrapper.hasClass("no-submenu") &&
        $("#page .main-container .components > div").hasClass(
          "onespan-switch-hero-bg"
        )
      ) {
        var contentPlacement =
          $(".sticky-header").position().top + $(".sticky-header").height();
        $("#page .main-container > header").css("margin-top", 145);
      }
      // If user is not logged in and you are on a event node, apply specific margin
      else if (
        $("body").hasClass("page-node-type-event") &&
        !$("body").hasClass("user-logged-in")
      ) {
        $(".page-node-type-event #page .main-container header .hero").css(
          "margin-top",
          94
        );
      }
      // If user is not logged in and is onespansign contact page, apply specific margin
      else if (
        $("#page .main-container .components > div").hasClass(
          "contact-hero-bg"
        ) &&
        !$("body").hasClass("user-logged-in")
      ) {
        $("#page .main-container > header > section:first-child").css(
          "margin-top",
          174
        );
      }
      // Else if user is not logged in, set margin-top of sticky-header height to header
      else {
        $("#page .main-container > header > section:first-child").css(
          "margin-top",
          contentPlacement
        );
      }
    }
    // Margin logic for mobile
    if (window.matchMedia("(max-width: 767px)").matches) {
      if (
        (!$("body").hasClass("user-logged-in") &&
          $menuWrapper.hasClass("not-fixed") &&
          $menuWrapper.hasClass("no-submenu")) ||
        (!$("body").hasClass("user-logged-in") &&
          $menuWrapper.hasClass("submenu-alert"))
      ) {
        $("#page .main-container > header > section:first-child").css(
          "margin-top",
          contentPlacement
        );
      } else if (
        !$("body").hasClass("user-logged-in") &&
        $("body").hasClass("page-node-type-page") &&
        $(".hero").hasClass("hero-webform")
      ) {
        $("#page .main-container header > section:first-child").css(
          "margin-top",
          49
        );
      }
    }

    let stickPoint;
    const stuckClass = "is-stuck";
    if ($(".fixed-bar").length || $(".sticky-bar").hasClass("menu-bar")) {
      stickPoint = $menuWrapper.outerHeight();
    } else if (
      $(".sticky-header").hasClass("not-fixed") &&
      $(".submenu-bar").hasClass("submenu-below-header") &&
      !$(".sticky-header").hasClass("sticky-bar")
    ) {
      stickPoint = $menuWrapper.outerHeight() + $header.outerHeight();
    } else {
      stickPoint = $topMenu.outerHeight() + $mainMenu.outerHeight();
    }

    const toggleStuck = Drupal.debounce(() => {
      const isStuck = $(document).scrollTop() >= stickPoint;
      $menuTarget.toggleClass(stuckClass, isStuck);
    }, 10);

    // Sets the value of two variables. Delta is the threshold by which we need scroll detection to occur (every 5px to prevent accidental or small scrolling)
    var lastScrollTop = 0,
      delta = 5;
    $(window).on("resize scroll", function() {
      var nowScrollTop = $(this).scrollTop();
      // Runs only if the absolute difference between lastScrollTop and nowScrollTop is < than delta (5px).
      if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
        // If it's a page that has no submenu
        if (
          $menuWrapper.hasClass("not-fixed") &&
          $menuWrapper.hasClass("no-submenu")
        ) {
          // if current scrolling value is greater than last scroll value, downward scrolling occurs
          if (nowScrollTop > lastScrollTop) {
            $menuTarget.addClass(stuckClass);
          } else {
            $menuTarget.removeClass(stuckClass);
          }
          lastScrollTop = nowScrollTop;
        } else if (
          $menuWrapper.hasClass("not-fixed") &&
          !$menuWrapper.hasClass("no-submenu")
        ) {
          toggleStuck();
        } else {
          // On scroll down
          if (nowScrollTop > lastScrollTop) {
            $menuTarget.addClass(stuckClass);
          }
          // On scroll up
          else {
            $menuTarget.removeClass(stuckClass);
          }
          lastScrollTop = nowScrollTop;
        }
      }
    });
    // toggleStuck();
    // $(window).on("resize scroll", toggleStuck);
  }

  function initMobileMenus() {
    var $mobilePane = $(".mobile-menu-pane");
    $mobilePane.find(".menu li").each(function(i) {
      const target = `mobile-menu-collapse-${i}`;
      const $subList = $(this).find("> ul");

      $(this).removeClass("expanded, dropdown");

      if ($subList.length) {
        $subList
          .attr("id", target)
          .addClass("collapse")
          .removeClass("dropdown-menu")
          .collapse({ toggle: false });

        $(this)
          .find("> a, > p, > div")
          .attr("data-target", "#" + target)
          .attr("href", null)
          .attr("data-toggle", "collapse");
      }
    });

    $mobilePane.on("show.bs.modal hide.bs.modal", function() {
      $('.hamburger[data-target="#mobile-pane"]').toggleClass("is-active");
    });

    // Adding top offset depending if there is a site-alert on the page
    var cssTop = parseInt($mobilePane.css("top").replace("px", ""));
    var $menuBar = $(".menu-bar");
    var $mainMobilePane = $("#mobile-pane");
    var $localization = $(".localization-block");

    $mainMobilePane.on("show.bs.modal", function() {
      var $siteAlert = $(".site-alert");

      if ($localization.length) $localization.hide();

      if ($siteAlert.length && !$menuBar.hasClass("is-stuck")) {
        $mainMobilePane.css("top", cssTop + $siteAlert.height());
      } else {
        $mainMobilePane.css("top", cssTop);
      }
    });
  }

  const initFooter = Drupal.debounce(() => {
    const xs = window.matchMedia("(min-width: 320px) and (max-width: 886px)");
    xs.matches ? initFooterMobile() : exitFooterMobile();
  });

  function initFooterMobile() {
    $(".menu--footer, .menu--footer-new").addClass("menu-collapse");
    $(
      ".menu--footer .lvl-0, .menu--footer .lvl-1, .menu--footer-new .lvl-0, .menu-footer-new .lvl-1"
    ).each(function(i) {
      const target = "mobile-footer-collapse-" + i;

      $(this)
        .find("> p, > div")
        .attr("data-target", "#" + target)
        .attr("role", "button")
        .attr("aria-expanded", "false")
        .attr("aria-controls", target)
        .attr("data-toggle", "collapse");

      $(this)
        .find("> ul")
        .attr("id", target)
        .addClass("collapse")
        .collapse({ toggle: false });
    });
  }

  function exitFooterMobile() {
    $(".menu--footer, .menu--footer-new").removeClass("menu-collapse");
    $(
      ".menu--footer .lvl-0, .menu--footer .lvl-1, .menu--footer-new .lvl-0, .menu--foter-new .lvl-1"
    ).each(function(i) {
      $(this)
        .find("> p, > div")
        .attr("data-target", null)
        .attr("data-toggle", null);

      $(this)
        .find("> ul")
        .removeClass("collapse")
        .css("height", null);
    });
  }
})(jQuery);
